<template>
  <v-layout
    :data-qa="shouldDisplayMatterName ? client.matter_name : client.full_name"
    :class="{'mobile-version': isMobile}"  align-center class="matter-client-info">
    <AvatarImage
      :image-path="client.photo_path"
      :name="client.full_name"
      :color-id="client.color_id"
      :custom-size="customAvatarSize"
      class="contact-avatar-wrapper"
    >
      <slot name="matter-avatar"></slot>
    </AvatarImage>
    <v-layout column class="client-details">
      <div class="matter-name">
        {{shouldDisplayMatterName ? client.matter_name : client.full_name}}
        <slot name="matter-name"></slot>
      </div>
      <v-layout v-if="shouldDisplayMatterName" class="client-name-container" align-center>
        <v-icon size="20px">
          icon-client-card
        </v-icon>
        <span class="client-name">
        {{client.full_name}}
      </span>
      </v-layout>
      <slot name="further-details">

      </slot>
    </v-layout>
    <slot></slot>
    <slot name="actions-activator">
      <DropdownMenu v-if="actions.length > 0" :items="actions" @item-clicked="(item) => $emit('action', item.event)">
        <v-btn icon class="three-dots activator-container" text height="24px" width="24px">
          <v-icon size="16">icon-dots-three-vertical</v-icon>
        </v-btn>
      </DropdownMenu>
    </slot>
  </v-layout>
</template>

<script>
  import {AvatarImage, VSvgIcon, VcitaDialog, DropdownMenu} from "@/modules/common/components";

  export default {
    components: {
      AvatarImage,
      VSvgIcon,
      VcitaDialog,
      DropdownMenu,

    },
    props: {
      client: {
        type: Object,
        required: true,
      },
      actions: {
        type: Array,
        default: () => [],
        validator: prop => prop.every(e => e.title && e.event),
      },
      customAvatarSize: {
        type: String,
        default: ''
      }
    },
    computed: {
      shouldDisplayMatterName() {
        return this.client.matter_name !== this.client.full_name
      },
      isMobile() {
        return this.$store.getters.isMobile
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/abstract/_i18n-mixins';
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_mixins.scss";
  .contact-avatar-wrapper {

    @include i-margin-mirror(0, 16px);
    @include md-and-up {
      @include i-margin-mirror(0, 13px);
      font-size: 13px;
      font-weight: 500;
      letter-spacing: -0.93px;
    }

  }

  .matter-name {
    font-family: var(--primary-font-family);
    font-size: 15px;
    font-weight: 500;
    font-stretch: normal;
    font-stretch: normal;
    line-height: 1.33;
    margin-bottom: 3px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    @include md-and-up {
      line-height: 1.29;
      letter-spacing: 0.1px;
      color: rgba(0, 0, 0, 0.87);
      margin-bottom: 0;
      font-size: 15px;
      font-weight: 500;
    }
  }
  .client-name-container {
    font-family: var(--primary-font-family);
    font-size: 13px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: rgba(0, 0, 0, 0.54);
  }
  .client-name {
    margin: 0 9px;
  }

  .matter-client-info {
    ::v-deep {
      .activator-container {
        @include md-and-up {
          display: none;
        }
      }
    }
    &:not(.mobile-version) {
      font-size: 13px;
      font-weight: 500;
      letter-spacing: -0.93px;
      .matter-name {
        line-height: 1.29;
        letter-spacing: 0.1px;
        color: rgba(0, 0, 0, 0.87);
        margin-bottom: 0;
        font-size: 15px;
        font-weight: 500;
      }
      ::v-deep {
        .activator-container {
          display: none;
        }
      }
      &:hover {
        ::v-deep {
          .activator-container {
            display: revert;
          }
        }
      }
    }
  }


</style>
